import React from 'react';
import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';

interface RightDrawerProps extends Omit<DrawerProps, 'placement'> {
  children: React.ReactNode;
}

const RightDrawer: React.FC<RightDrawerProps> = ({ children, rootClassName, ...props }) => {
  return (
    <Drawer placement="right" mask={false} rootClassName={['right-drawer-shell', rootClassName].filter(Boolean).join(' ')} {...props}>
      {children}
    </Drawer>
  );
};

export default RightDrawer;
